import { FBC_COOKIE, FBP_COOKIE, META_EVENT_SOURCE_URL_HEADER, META_FBC_HEADER, META_FBP_HEADER } from "@/platform/api/constants"
import { redactAuthUrl } from "@/platform/api/redact-auth-url"
import { getSessionCookie } from "@/platform/session/auth/get-session-cookie-client"

export function buildMetaHeaders(): Record<string, string> {
  const headers: Record<string, string> = {}
  const fbp = getSessionCookie(FBP_COOKIE)
  const fbc = getSessionCookie(FBC_COOKIE)

  if (fbp) headers[META_FBP_HEADER] = fbp
  if (fbc) headers[META_FBC_HEADER] = fbc
  if (typeof window !== "undefined") headers[META_EVENT_SOURCE_URL_HEADER] = redactAuthUrl(window.location.href)

  return headers
}
